import { mount } from '../../dom-lifecycle';

mount('#recover-password-form', function (form) {
    const formPanel = document.getElementById('js-recover-form-panel');
    const successPanel = document.getElementById('js-recover-success-panel');
    const emailDisplay = document.getElementById('js-recover-email-display');

    $(form).on('submit-success', function (event) {
        event.preventDefault();
        const emailInput = form.querySelector('input[type="email"]');
        if (emailDisplay) emailDisplay.textContent = emailInput ? emailInput.value : '';
        if (formPanel) formPanel.style.display = 'none';
        if (successPanel) successPanel.style.display = '';
    });
});
